<template>
  <div>
    <button class="bg-white inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm 2xl:text-sm sm:text-xl font-medium rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500" v-on:click="onClick">
      <span>
      {{parentfield.label}}
      </span>
    </button>
    <div v-if="showmodal" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
          <div class="mt-2 flex flex-col">
            <div class="mx-4 pb-4 p-4 2xl:pb-16">
              <template v-for="field in fields.fields">
                <template v-if="!field.hidden">
                  <div class="col-span-6" v-bind:key="field.key">
                    <label for="field.label" class=" mt-4 block 2xl:text-sm sm:text-xl font-medium leading-5 text-gray-700">
                      {{field.label}}
                    </label>
                    <div class="rounded-md shadow-sm">
                      <div class="flex">
                        <div class="flex-grow mt-2">
                          <input type="number" @change="updateValue(field.key, $event.target.value)" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full 2xl:text-sm sm:text-xl border-gray-300 shadow-sm rounded-md">
                        </div>
                      </div>
                    </div>
                  </div>

                </template>
              </template>
            </div>
          </div>
          <div class="mt-5 sm:mt-6">
            <button type="button" @click="showmodal = false" class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 2xl:text-sm sm:text-xl">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'modal-field',
  data() {
    return {
      showmodal: false,
      fields: [],
      fdata: {}
    }
  },
  props: {
    parentfield: {
      type: Object,
      required: true
    },
  },
  async created() {
    console.log('modal', this.$route.params)
    //this.getFormFields()
  },
  methods: {
    async getFormFields() {
      const response = await this.$http.get(`forms?form=flowform&params=${this.parentfield.uri}`)
      this.fields = response.data
    },
    updateValue(key, value) {
      this.fdata[key] = JSON.parse(JSON.stringify(value))
      this.$parent.updateValue(this.parentfield.key, this.fdata)
    },
    onClick() {
      this.$router.push('/form/' + this.parentfield.uri + '/0' + '?' + this.$route.params.blueprint + '=' + this.$route.params.record)
      this.$router.go()
    }
  }

}
</script>
